import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (location.pathname.match(/\/matricula\/contrato\/dados/)) {
      this.openContract();
    }
    if (location.pathname.match(/matricula\/contrato\/educacional/)) {
      this.openContractEducational();
    }
    if (location.pathname.match(/matricula\/contrato\/termo/)) {
      this.openContractTerm();
    }
  }

  generateLead(event) {
    this.clearEvent();
    const form = event.currentTarget.closest('form');
    if (!form || !form.checkValidity()) return;

    dataLayer.push({
      event: 'generate_lead'
    });
  }

  openContract() {
    this.clearEvent();
    dataLayer.push({
      event: 'start_contract'
    });

    this.clearEvent();
    dataLayer.push({
      event: 'contract_dados'
    });    
  }

  openContractEducational() {
    this.clearEvent();
    dataLayer.push({
      event: 'contract_educacional'
    });
  }

  openContractTerm() {
    this.clearEvent();
    dataLayer.push({
      event: 'contract_termo'
    });
  }

  clearEvent() {
    dataLayer.push({ ecommerce: null });
  }

  endContract() {
    this.clearEvent();
    dataLayer.push({
      event: 'IGUA'
    });
  }
}